<template>
    <div style="margin:0 -12px;">
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <i class="bi bi-chevron-left" onclick="window.location.href = '/auth'"></i>
                    </div>
                    <div class="col text-center">
                    </div>
                    <div class="col-1">
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap">
            <br>
            <div class="container-fluid" style="padding-top:56px;">
                <div class="row justify-content-center">
                    <div class="col-11">
                        <div style="font-size:30px;color:#6C7072;">
                            パスワードを<br>
                            入力してください
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <div class="row justify-content-center">
                    <div class="col-11">
                        <p class="error-text" id="error-box" v-if="is_login_error">
                            <i class="bi bi-x-circle-fill"></i>登録されていないメールアドレスです。
                        </p>
                        <input type="password" class="luna-form-control" id="luna_password" name="luna_password"
                            v-model="luna_password" />
                        <p class="error-text" v-if="isPasswordTooShort">
                            <i class="bi bi-x-circle-fill"></i>パスワードは{{ minPasswordLength }}文字以上で入力してください
                        </p>
                        <p class="error-text" v-if="isPasswordMissingCharTypes">
                            <i class="bi bi-x-circle-fill"></i>パスワードは英字と数字をそれぞれ含めてください
                        </p>
                        <br />
                        <br />
                        <div>
                            <small> 確認用 </small>
                        </div>
                        <input type="password" class="luna-form-control" id="luna_password_conf" name="luna_password_conf"
                            v-model="luna_password_conf" />
                        <p class="error-text" v-if="isPasswordMismatch">
                            <i class="bi bi-x-circle-fill"></i>確認用パスワードが一致しません
                        </p>
                        <br />
                        <br />
                        <div class="d-grid gap-2" style="padding: 0 5px;">
                            <button type="button" class="btn btn-luna disabled" style="font-size:18px; padding:12px 0;"
                                v-if="is_load">
                                <div class="spinner-border" style="width: 1rem; height: 1rem;" role="status" v-if="is_load">
                                    <span class="visually-hidden">Loading...</span>
                                </div>設定する
                            </button>
                            <button type="button" class="btn btn-luna" style="font-size:18px; padding:12px 0;"
                                @click="setPass()" v-else-if="isInValidPass">設定する</button>
                            <button type="button" class="btn btn-luna-d disabled" style="font-size:18px; padding:12px 0;"
                                v-else>設定する</button>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_login_error: false,
            luna_password: "",
            luna_password_conf: "",
            minPasswordLength: 8,
            is_load: false,
        };
    },
    methods: {
        async setPass() {
            if (this.luna_password.length < this.minPasswordLength) {
                this.$showErrorToast(`パスワードは${this.minPasswordLength}文字以上で入力してください`)
                return
            }
            if (this.isPasswordMissingCharTypes) {
                this.$showErrorToast('パスワードは英字と数字をそれぞれ含めてください')
                return
            }
            if (this.luna_password !== this.luna_password_conf) {
                this.$showErrorToast('パスワードが一致しません')
                return
            }
            this.is_load = true

            await axios.post("/api/auth/pass/change", {
                email: this.$route.query.email,
                password: this.luna_password,
            })
                .then((response) => {
                    if (response.data.res == '546') {
                        this.is_login_error = true
                    }
                    else {
                        window.location.href = '/auth?password_changed=true'
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast('パスワードの変更に失敗しました。');
                    }
                }).finally(() => {
                    this.is_load = false
                });
        },
    },
    computed: {
        isPasswordTooShort() {
            return this.luna_password !== "" && this.luna_password.length < this.minPasswordLength
        },
        isPasswordMissingCharTypes() {
            if (this.luna_password === "") {
                return false
            }
            const hasLetter = /[A-Za-z]/.test(this.luna_password)
            const hasNumber = /[0-9]/.test(this.luna_password)
            return !(hasLetter && hasNumber)
        },
        isPasswordMismatch() {
            if (this.luna_password === "" || this.luna_password_conf === "") {
                return false
            }
            return this.luna_password !== this.luna_password_conf
        },
        isInValidPass() {
            if (this.luna_password === "" || this.luna_password_conf === "") {
                return false
            }
            if (this.isPasswordTooShort) {
                return false
            }
            if (this.isPasswordMissingCharTypes) {
                return false
            }
            if (this.isPasswordMismatch) {
                return false
            }

            return this.luna_password === this.luna_password_conf
        }
    },
}
</script>
<style scoped>
.link {
    color: #212529
}

.link:hover {
    color: #212529
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    padding-top: 20px;
    height: 60px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
